import { Link } from "react-router-dom";
import type { Project } from "@/lib/types";

export default function ProjectCard({ project }: { project: Project }) {
  const slug = project.slug || project.id;
  return (
    <article className="group flex flex-col h-full rounded-2xl overflow-hidden border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(30,60,120,0.12)]">
      <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
        {project.imagen && (
          <img
            src={project.imagen}
            alt={`${project.nombre} - ${project.categoria || ""}`}
            title={`${project.nombre} - ${project.categoria || ""}`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        {project.categoria && (
          <span className="absolute top-4 left-4 rounded-full bg-background-50/90 backdrop-blur px-3 py-1 text-xs font-semibold text-primary-700">
            {project.categoria}
          </span>
        )}
        {project.url && (
          <a
            href={project.url}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-background-50/90 backdrop-blur text-foreground-800 opacity-0 group-hover:opacity-100 transition-all hover:bg-primary-500 hover:text-background-50 cursor-pointer"
            aria-label={`Abrir sitio de ${project.nombre}`}
          >
            <i className="ri-external-link-line text-base" />
          </a>
        )}
      </div>

      <div className="flex flex-col flex-1 p-5 md:p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-lg md:text-xl font-semibold text-foreground-950">
            {project.nombre}
          </h3>
          {project.anio && (
            <span className="text-xs text-foreground-400 whitespace-nowrap">
              {project.anio}
            </span>
          )}
        </div>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
          {project.descripcion}
        </p>

        {(project.tecnologias ?? []).length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-5">
            {(project.tecnologias ?? []).slice(0, 4).map((tech) => (
              <span
                key={tech}
                className="rounded-full bg-secondary-100 text-secondary-800 px-2.5 py-1 text-[11px] font-medium"
              >
                {tech}
              </span>
            ))}
          </div>
        )}

        <div className="mt-auto flex items-center gap-3">
          <Link
            to={`/proyecto/${slug}`}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            Ver proyecto
            <i className="ri-arrow-right-line text-base" />
          </Link>
          {project.url && (
            <a
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-500 hover:text-foreground-800 transition-colors whitespace-nowrap"
            >
              Abrir sitio
              <i className="ri-external-link-line text-base" />
            </a>
          )}
        </div>
      </div>
    </article>
  );
}